export const linkModelAttributes = {
    href: "linkHref",
    isExternal: "linkIsExternal"
} as const;
